/** @jsx jsx */

import { capitalize } from 'lodash';

import { jsx } from '@emotion/core';
import {
  Alert,
  AlertDescription,
  Button,
  ButtonGroup,
  Link,
  Margin,
} from '@zapier/design-system';
import { Icon } from '@zapier/zinnia-icons';

import {
  GET_HELP_CTA,
  GET_HELP_PATH,
} from 'app/developer-v3/teams/team-technical-support-operations/get-help';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

const ErrorPage = () => {
  return (
    <Margin margin="40px">
      <Alert status="error" title="Our API seems to be down!">
        <AlertDescription>
          We are sorry for the inconvenience. Please try again later or contact
          support
        </AlertDescription>
      </Alert>
      <Margin margin="40px 0px 0px">
        <ButtonGroup columnSize="minmax(100px, max-content)" justify="center">
          <Button
            aria-label="Click to reload the page"
            variant="primary"
            onPress={() => window.location.reload()}
            iconPosition="start"
          >
            <Icon name="arrowRefresh" />
            Reload
          </Button>
          <Link
            aria-label="Click to follow a link to the help page"
            variant="tertiary"
            href={`${ZAPIER_APP_BASE_URL}${GET_HELP_PATH}`}
            iconPosition="start"
            target="_blank"
          >
            <Icon name="commentBlankFill" />
            {capitalize(GET_HELP_CTA)}
          </Link>
        </ButtonGroup>
      </Margin>
    </Margin>
  );
};

export default ErrorPage;
